module.exports = __webpack_public_path__ + "img/24.fabcddf1.jpg";